import axios from "axios";
import { keys } from "../utils/keys";
import { logError } from "../utils/errors/logger";

const getAPIResponse = async (params) => {
  try {
    const axiosRes = await axios.get(keys.general.graphqlUrl, {
      paramsSerializer: { indexes: null },
      params,
    });
    return axiosRes.data;
  } catch (error) {
    logError({ error, message: "getCategoryMeta", info: { params } });
    return { data: [], errors: error };
  }
};

export const getCategoryMeta = async ({ catId }) => {
  return getAPIResponse({
    variables: JSON.stringify({
      categoryfilters: { ids: { in: [catId] } },
    }),
    query: `query ProductFilter ($categoryfilters: CategoryFilterInput) {
      categoryList (filters: $categoryfilters) {
        id name image meta_title meta_keywords meta_description
      }
    }`,
  });
};

export const getProductMeta = async ({ productSKU }) => {
  return getAPIResponse({
    variables: JSON.stringify({
      productfilters: { sku: { eq: productSKU } },
    }),
    query: `query ProductFilter ($productfilters: ProductAttributeFilterInput) {
      products (filter: $productfilters) {
        items {
          id name meta_title meta_keyword meta_description
          thumbnail { url label }
          extraVariable { brand_info { title } }
        }
      }
    }`,
  });
};
